import React from "react";
import EllipsisTooltip from "shared/components/common/EllipsisTooltip";
import { PillarTableColumnProps } from "shared/components/pillar-table/columns/PillarTableColumn";
import PillarTableColumnText from "shared/components/pillar-table/columns/PillarTableColumnText";
import { PillarTableSafeAny } from "shared/components/pillar-table/PillarTableSafeAny";
import { usePillarTableRowContext } from "shared/components/pillar-table/row/PillarTableRowContext";
import { DeepKeys } from "shared/types/deepkeys";

const PillarTableCellContent = <RowGeneric = PillarTableSafeAny,>(
  props: PillarTableColumnProps<RowGeneric>,
) => {
  const { rowValue } = usePillarTableRowContext();

  const { children, ...restProps } = props;

  if ("children" in props === false) {
    return (
      <EllipsisTooltip className={restProps?.contentClassName || ""}>
        <PillarTableColumnText
          cellValuePath={props.valueProperty as DeepKeys<RowGeneric>}
          {...restProps}
        />
      </EllipsisTooltip>
    );
  }

  if (typeof children === "function") {
    return (
      <EllipsisTooltip className={restProps?.contentClassName || ""}>
        {children(rowValue)}
      </EllipsisTooltip>
    );
  }

  const validChildren = React.Children.toArray(children)
    .filter((child) => React.isValidElement(child))
    .map((child) =>
      React.isValidElement(child)
        ? React.cloneElement(child, {
            ...restProps,
            children: child.props.children,
          } as unknown as React.ReactElement)
        : child,
    );
  if (validChildren.length === 1 && React.isValidElement(validChildren[0])) {
    return (
      <EllipsisTooltip className={restProps?.contentClassName || ""}>
        {React.cloneElement(validChildren[0], {
          ...{
            ...{ cellValuePath: props.valueProperty as PillarTableSafeAny },
            ...restProps,
          },
        })}
      </EllipsisTooltip>
    );
  }

  return (
    <EllipsisTooltip className={restProps?.contentClassName || ""}>
      <>Unknown Cell Content Type???</>
    </EllipsisTooltip>
  );
};

export default PillarTableCellContent;
